module.exports = require("./vai-Latn.d.ts");